import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/main.scss';

import homeDesktopLogo from '../assets/logos/preto_caramelo_4.png';
import homeMobileLogo from '../assets/logos/preto_caramelo_4.png';
import loginLogo from '../assets/logos/preto_caramelo_3.png';
import cadastroDesktopLogo from '../assets/logos/bege_preto_3_top_left_bottom_right.png';
import cadastroMobileLogo from '../assets/logos/bege_preto_3_top_left_bottom_right.png';
import iacLogo from '../assets/logos/logotipo_iac.png';

window.APP_ASSETS = {
    homeDesktopLogo,
    homeMobileLogo,
    loginLogo,
    cadastroDesktopLogo,
    cadastroMobileLogo,
    iacLogo,
};

window.getPageAssets = (pageKey) => {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    let convexasLogo = window.APP_ASSETS.homeDesktopLogo;

    if (pageKey === 'cadastro') {
        convexasLogo = isMobile
            ? window.APP_ASSETS.cadastroMobileLogo
            : window.APP_ASSETS.cadastroDesktopLogo;
    } else if (pageKey === 'login') {
        convexasLogo = window.APP_ASSETS.loginLogo;
    } else {
        convexasLogo = isMobile
            ? window.APP_ASSETS.homeMobileLogo
            : window.APP_ASSETS.homeDesktopLogo;
    }

    return {
        'convexas-logo': convexasLogo,
        'iac-logo': window.APP_ASSETS.iacLogo,
    };
};
